export default {
  header: {
    main: ".header",
  },
  main: {
    content: ".main",
  },
  starting: {
    logo: ".starting__logo",
  },
  mission: {
    top: {
      text1_1: ".mission__a1",
      text1_2: ".mission__a2",
      bg: ".mission__a5",
    },
    bottom: {
      text1_1: ".mission__a3",
      text1_2: ".mission__a4",
      bg: ".mission__a6",
    },
    imgWrapper: ".mission__image-wrapper--bottom",
  },
  match: {
    text: {
      text1_1: ".match__a1",
      text1_2: ".match__a2",
    },
    button: ".match__a3",
    toolbar: ".match__toolbar",
  },
  gallery: {
    text: {
      text1_1: ".gallery__a1",
      text1_2: ".gallery__a2",
      text1_3: ".gallery__a3",
      text1_4: ".gallery__a4",
      text1_5: ".gallery__a5",
      text1_6: ".gallery__a6",
      text1_7: ".gallery__a7",
    },
    // button: ".gallery__a8",
    toolbar: ".gallery__toolbar",
  },
  proof: {
    text: {
      text1_1: ".proof__a1",
    },
    button: ".proof__a2",
  },
  join: {
    items: [".join__a1", ".join__a2", ".join__a3", ".join__a4", ".join__a5"],
    button: ".proof__a2",
  },
};
